/**
* File utility functions
*/

/**
* Determine message type from file MIME type
*/
export function getMessageTypeFromFile(file: File): string {
    if (file.type.startsWith('image/')) return 'image'
    if (file.type.startsWith('video/')) return 'video'
    if (file.type.startsWith('audio/')) return 'audio'
    
    // Check common document MIME types
    if (
        file.type === 'application/pdf' ||
        file.type.includes('wordprocessingml') ||
        file.type.includes('spreadsheetml') ||
        file.type.includes('presentationml') ||
        file.type === 'application/msword' ||
        file.type === 'application/vnd.ms-excel' ||
        file.type === 'application/vnd.ms-powerpoint' ||
        file.type === 'text/plain' ||
        file.type === 'text/csv'
    ) {
        return 'document'
    }
    
    return 'file' // Generic file type
}

/**
* Get file icon emoji based on MIME type or message type
*/
export function getFileIcon(mimeType?: string, type?: string): string {
    if (!mimeType && !type) return '📎'
    
    const mime = mimeType?.toLowerCase() || ''
    const msgType = type?.toLowerCase() || ''
    
    if (mime.startsWith('image/') || msgType === 'image') return '🖼️'
    if (mime.startsWith('video/') || msgType === 'video') return '🎥'
    if (mime.startsWith('audio/') || msgType === 'audio') return '🎵'
    if (mime === 'application/pdf' || msgType === 'document') return '📄'
    if (mime.includes('word')) return '📝'
    if (mime.includes('excel') || mime.includes('spreadsheet')) return '📊'
    if (mime.includes('powerpoint') || mime.includes('presentation')) return '📊'
    
    return '📎'
}

/**
* Convert file to base64 data URL
*/
export function fileToBase64(file: File): Promise<string> {
    return new Promise((resolve, reject) => {
        const reader = new FileReader()
        reader.onloadend = () => {
            if (typeof reader.result === 'string') {
                resolve(reader.result)
            } else {
                reject(new Error('Failed to convert file to base64'))
            }
        }
        reader.onerror = reject
        reader.readAsDataURL(file)
    })
}

/**
* Create image preview from file
*/
export function createImagePreview(file: File): Promise<string> {
    return new Promise((resolve, reject) => {
        if (!file.type.startsWith('image/')) {
            reject(new Error('File is not an image'))
            return
        }
        
        const reader = new FileReader()
        reader.onloadend = () => {
            if (typeof reader.result === 'string') {
                resolve(reader.result)
            } else {
                reject(new Error('Failed to create image preview'))
            }
        }
        reader.onerror = reject
        reader.readAsDataURL(file)
    })
}
